import { FC, useState } from 'react';
import { BlockResize } from 'components/BlockResize';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Field } from 'ui/Field';
import { ReactComponent as Fns1 } from 'assets/img/taxStatus/ФНС.svg';
import { ReactComponent as Fns2 } from 'assets/img/taxStatus/fns2.svg';
import { ReactComponent as Fns3 } from 'assets/img/taxStatus/error.svg';
import styles from './FNSStatus.module.scss';
import { Button } from 'ui/Button';
import { Modal } from 'components/Modal';
import { Title } from 'components/Title';
import modalStyles from './WorkerContentModal.module.scss';
import { useParams } from 'react-router';

export const FNSStatus: FC = () => {
  const { infoEmployeds, openBlock } = useSelector(
    (state: RootState) => state.employedsDetailSlice,
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
  const [actionTitle, setActionTitle] = useState('');
  const [actionheading, setActionHeading] = useState('');
  const { id } = useParams();

  const showConfirmation = (action: () => void, heading: string, title: string) => {
    setPendingAction(() => action);
    setActionHeading(heading);
    setActionTitle(title);
    setConfirmationModal(true);
  };

  const confirmAction = () => {
    if (pendingAction) {
      pendingAction();
    }
    setConfirmationModal(false);
    setPendingAction(null);
  };

  const cancelAction = () => {
    setConfirmationModal(false);
    setPendingAction(null);
  };

  const sendDataFNSChangeHandler = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/worksupport/workers-app/${id}/refresh-fns-profile`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        setModalMessage('Данные ФНС успешно обновлены');
      } else {
        setModalMessage(data.message || 'Произошла ошибка при обновлении данных ФНС');
      }
    } catch {
      setModalMessage(
        'Произошла ошибка при обновлении данных ФНС, повторите запрос позднее',
      );
    }
    setModalOpen(true);
  };

  const sendDataConnectionRequestChangeHandler = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/worksupport/workers-app/${id}/bind`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        setModalMessage(data.message);
      } else {
        setModalMessage(data.message);
      }
    } catch {
      setModalMessage('Произошла ошибка при подключении, повторите запрос позднее');
    }
    setModalOpen(true);
  };

  const sendDataDisconnectRequestChangeHandler = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/worksupport/workers-app/${id}/unbind`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        setModalMessage(data.message);
      } else {
        setModalMessage(data.message);
      }
    } catch {
      setModalMessage('Произошла ошибка при отключении, повторите запрос позднее');
    }
    setModalOpen(true);
  };

  const { worker_fns } = infoEmployeds || {};

  type FnsStatusKey = '-2' | '-1' | '0' | '1' | '2' | '3';

  const fns_status: Record<FnsStatusKey, string> = {
    '-2': 'Исполнитель отозвал доступ к приложению Мой налог',
    '-1': 'Исполнитель отозвал доступ к приложению Мой налог',
    '0': 'Исполнитель не подключен к Скилла Работа',
    '1': 'Исполнитель предоставил доступ к приложению Мой налог без права оплаты налогов',
    '2': 'Исполнитель предоставил доступ к приложению Мой налог с правом оплаты налогов',
    '3': 'Исполнителю отправлено приглашение в "Мой налог"',
  };

  const statusNiber = String(worker_fns?.fns_status) as FnsStatusKey;

  return (
    <BlockResize open={openBlock} title='Налоговый статус'>
      <div className={styles.root}>
        <div className={styles.row}>
          <Field style={{ width: '192px' }} placeholder='ИНН' title={worker_fns?.inn} />
        </div>

        <div className={styles.block}>
          <div className={styles.block_svg}>
            {worker_fns?.fns_status === 2 ? (
              <Fns1 />
            ) : worker_fns?.fns_status === 1 ? (
              <Fns2 />
            ) : (
              <Fns3 />
            )}
          </div>
          <div className={styles.block_text}>
            <p className={styles.block_text_title}>Оплата налогов от имени исполнителя</p>
            <p className={styles.block_text_subTitle}>{fns_status[statusNiber]}</p>
          </div>
        </div>
        <div className={styles.taxButton}>
          <Button
            onClick={() =>
              showConfirmation(
                sendDataConnectionRequestChangeHandler,
                ' Подтверди отправку приглашения',
                'Отправить приглашение на подключение в “Мой налог”?',
              )
            }
            theme='outline'
            className={styles.textPadding}>
            Подключить
          </Button>
          <Button
            onClick={() =>
              showConfirmation(
                sendDataDisconnectRequestChangeHandler,
                'Подтверди отключение от "Мой налог"',
                'Отправить запрос на отключение от “Мой налог”?',
              )
            }
            className={styles.btn_disabling}
            theme='danger'>
            Отключить
          </Button>
          <Button
            onClick={() => sendDataFNSChangeHandler()}
            className={styles.textPadding}
            theme='filed'>
            Обновить данные
          </Button>
        </div>
        {modalOpen && (
          <Modal setOpen={setModalOpen}>
            <div className={modalStyles.root}>
              <Title className={modalStyles.title} title='Уведомление' />
              <p className={modalStyles.message}>{modalMessage}</p>
              <div className={modalStyles.buttons}>
                <Button
                  onClick={() => setModalOpen(false)}
                  className={modalStyles.button}
                  theme='filed'>
                  Закрыть
                </Button>
              </div>
            </div>
          </Modal>
        )}
        {confirmationModal && (
          <Modal setOpen={setConfirmationModal}>
            <div className={modalStyles.root}>
              <Title className={modalStyles.title} title={actionheading} />
              <p className={modalStyles.message}>{actionTitle}</p>
              <div className={modalStyles.buttons} style={{ gap: '12px' }}>
                <Button
                  onClick={confirmAction}
                  className={modalStyles.button}
                  theme='filed'>
                  Подтвердить
                </Button>
                <Button
                  onClick={cancelAction}
                  theme='danger'
                  className={modalStyles.button_cancel}>
                  Отмена
                </Button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </BlockResize>
  );
};
